module.exports = __webpack_public_path__ + "img/location.6f9d3a51.png";